import { useState, useEffect } from "react";
import { Download, X } from "lucide-react";

export function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      // Update UI notify the user they can install the PWA
      setShowPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    
    // Show the install prompt
    deferredPrompt.prompt();
    
    // Wait for the user to respond to the prompt
    await deferredPrompt.userChoice;
    
    // We've used the prompt, and can't use it again, throw it away
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] animate-in slide-in-from-bottom-8 fade-in duration-500">
      <div className="bg-[#0b0e11]/95 backdrop-blur-xl border border-[var(--color-border)] shadow-[0_8px_32px_rgba(0,0,0,0.5)] rounded-2xl p-4 w-72 flex items-start gap-4">
        <div className="flex-shrink-0 size-10 rounded-xl bg-gradient-to-tr from-emerald-500 to-emerald-400 flex items-center justify-center text-white shadow-inner">
          <Download className="size-5" />
        </div>
        
        <div className="flex-1 min-w-0 pt-0.5">
          <h3 className="text-sm font-black text-white uppercase tracking-tight">Install App</h3>
          <p className="text-[11px] text-white/60 leading-tight mt-1 mb-3">
            Install Solclaw to your device for a faster, native-like experience.
          </p>
          <div className="flex items-center gap-2">
            <button 
              onClick={handleInstallClick}
              className="flex-1 bg-emerald-500/10 hover:bg-emerald-500/20 border border-emerald-500/30 text-emerald-400 text-[11px] font-bold uppercase tracking-widest py-1.5 rounded-lg transition-colors"
            >
              Install
            </button>
          </div>
        </div>

        <button 
          onClick={() => setShowPrompt(false)}
          className="absolute top-3 right-3 text-white/40 hover:text-white transition-colors p-1"
        >
          <X className="size-3.5" />
        </button>
      </div>
    </div>
  );
}
